var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTamara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 19,
    viewBox: "0 0 97 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1532 4.6001H39.202H34.7615H30.8115V8.41392V18.4353H34.7615V8.41392H39.202V18.4353H43.1532V8.41392H47.5925V18.4353H51.5437V8.41392V4.6001H47.5925H43.1532Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88596 8.41266H10.6485V4.59884H6.88596V0.0749937L6.69729 0L0 5.68263V8.41266H2.93478V14.3953V18.4341H6.88596H11.0246V14.3953H6.88596V8.41266Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2855 5.83729C22.0512 4.75592 20.7512 4.3374 19.2224 4.3374C15.3467 4.3374 12.6748 7.25371 12.6748 11.4038C12.6748 15.5539 15.3467 18.4702 19.2224 18.4702C20.7524 18.4702 22.0525 18.0517 23.2855 16.9703V18.4339H27.048V4.59867H23.2855V5.83729ZM19.9746 15.0676C17.7544 15.0676 16.5505 13.4601 16.5505 11.4038C16.5505 9.3475 17.7544 7.73996 19.9746 7.73996C22.1949 7.73996 23.361 9.3475 23.361 11.4038C23.361 13.4601 22.1571 15.0676 19.9746 15.0676Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4457 4.59867V5.83729C91.2114 4.75592 89.9114 4.3374 88.3825 4.3374C84.5068 4.3374 81.835 7.25371 81.835 11.4038C81.835 15.5539 84.5068 18.4702 88.3825 18.4702C89.9126 18.4702 91.2126 18.0517 92.4457 16.9703V18.4339H96.2082V4.59867H92.4457ZM89.1336 15.0676C86.9133 15.0676 85.7095 13.4601 85.7095 11.4038C85.7095 9.3475 86.9133 7.73996 89.1336 7.73996C91.3538 7.73996 92.5199 9.3475 92.5199 11.4038C92.5199 13.4601 91.3161 15.0676 89.1336 15.0676Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9838 5.83729C63.7495 4.75592 62.4495 4.3374 60.9206 4.3374C57.0449 4.3374 54.373 7.25371 54.373 11.4038C54.373 15.5539 57.0449 18.4702 60.9206 18.4702C62.4507 18.4702 63.7507 18.0517 64.9838 16.9703V18.4339H68.7463V4.59867H64.9838V5.83729ZM61.6729 15.0676C59.4526 15.0676 58.2488 13.4601 58.2488 11.4038C58.2488 9.3475 59.4526 7.73996 61.6729 7.73996C63.8931 7.73996 65.0592 9.3475 65.0592 11.4038C65.0592 13.4601 63.8554 15.0676 61.6729 15.0676Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2744 5.9634V4.52279H72.3232V18.433H76.2744V9.80867L80.8647 8.15033V4.29902L80.7137 4.18652L76.2744 5.9634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamara);
export default __webpack_public_path__ + "static/media/Tamara.b7dfa464506e63a63962fb849181cc2a.svg";
export { ForwardRef as ReactComponent };